<template>
    <div class="relative" :class="{ 'opacity-50': disabled }">
        <datepicker
            :disabled-dates="disabledDates"
            :value="valueAsJsDate"
            :format="formatter"
            :disabled="disabled"
            placeholder="Day"
            :monday-first="true"
            maximum-view="day"
            @selected="update"
        />
        <svg
            class="absolute top-0 right-0 mt-5 mr-6"
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            focusable="false"
            aria-label="Date Picker"
        >
            <path
                d="M7 13.5287C7.13845 13.5287 7.27379 13.4877 7.3889 13.4107C7.50401 13.3338 7.59373 13.2245 7.64672 13.0966C7.6997 12.9687 7.71356 12.8279 7.68655 12.6921C7.65954 12.5564 7.59287 12.4316 7.49497 12.3337C7.39708 12.2358 7.27235 12.1692 7.13656 12.1422C7.00078 12.1152 6.86003 12.129 6.73212 12.182C6.60421 12.235 6.49489 12.3247 6.41797 12.4398C6.34105 12.5549 6.3 12.6903 6.3 12.8287C6.3 13.0144 6.37375 13.1924 6.50503 13.3237C6.6363 13.455 6.81435 13.5287 7 13.5287ZM10.5 13.5287C10.6384 13.5287 10.7738 13.4877 10.8889 13.4107C11.004 13.3338 11.0937 13.2245 11.1467 13.0966C11.1997 12.9687 11.2136 12.8279 11.1865 12.6921C11.1595 12.5564 11.0929 12.4316 10.995 12.3337C10.8971 12.2358 10.7724 12.1692 10.6366 12.1422C10.5008 12.1152 10.36 12.129 10.2321 12.182C10.1042 12.235 9.99489 12.3247 9.91797 12.4398C9.84105 12.5549 9.8 12.6903 9.8 12.8287C9.8 13.0144 9.87375 13.1924 10.005 13.3237C10.1363 13.455 10.3143 13.5287 10.5 13.5287ZM10.5 10.7287C10.6384 10.7287 10.7738 10.6877 10.8889 10.6107C11.004 10.5338 11.0937 10.4245 11.1467 10.2966C11.1997 10.1687 11.2136 10.0279 11.1865 9.89215C11.1595 9.75636 11.0929 9.63163 10.995 9.53374C10.8971 9.43584 10.7724 9.36917 10.6366 9.34216C10.5008 9.31515 10.36 9.32901 10.2321 9.382C10.1042 9.43498 9.99489 9.5247 9.91797 9.63981C9.84105 9.75493 9.8 9.89026 9.8 10.0287C9.8 10.2144 9.87375 10.3924 10.005 10.5237C10.1363 10.655 10.3143 10.7287 10.5 10.7287ZM7 10.7287C7.13845 10.7287 7.27379 10.6877 7.3889 10.6107C7.50401 10.5338 7.59373 10.4245 7.64672 10.2966C7.6997 10.1687 7.71356 10.0279 7.68655 9.89215C7.65954 9.75636 7.59287 9.63163 7.49497 9.53374C7.39708 9.43584 7.27235 9.36917 7.13656 9.34216C7.00078 9.31515 6.86003 9.32901 6.73212 9.382C6.60421 9.43498 6.49489 9.5247 6.41797 9.63981C6.34105 9.75493 6.3 9.89026 6.3 10.0287C6.3 10.2144 6.37375 10.3924 6.50503 10.5237C6.6363 10.655 6.81435 10.7287 7 10.7287ZM11.9 2.32871H11.2V1.62871C11.2 1.44306 11.1263 1.26501 10.995 1.13374C10.8637 1.00246 10.6857 0.928711 10.5 0.928711C10.3143 0.928711 10.1363 1.00246 10.005 1.13374C9.87375 1.26501 9.8 1.44306 9.8 1.62871V2.32871H4.2V1.62871C4.2 1.44306 4.12625 1.26501 3.99497 1.13374C3.8637 1.00246 3.68565 0.928711 3.5 0.928711C3.31435 0.928711 3.1363 1.00246 3.00503 1.13374C2.87375 1.26501 2.8 1.44306 2.8 1.62871V2.32871H2.1C1.54305 2.32871 1.0089 2.54996 0.615076 2.94379C0.221249 3.33761 0 3.87176 0 4.42871V14.2287C0 14.7857 0.221249 15.3198 0.615076 15.7136C1.0089 16.1075 1.54305 16.3287 2.1 16.3287H11.9C12.457 16.3287 12.9911 16.1075 13.3849 15.7136C13.7788 15.3198 14 14.7857 14 14.2287V4.42871C14 3.87176 13.7788 3.33761 13.3849 2.94379C12.9911 2.54996 12.457 2.32871 11.9 2.32871ZM12.6 14.2287C12.6 14.4144 12.5263 14.5924 12.395 14.7237C12.2637 14.855 12.0857 14.9287 11.9 14.9287H2.1C1.91435 14.9287 1.7363 14.855 1.60503 14.7237C1.47375 14.5924 1.4 14.4144 1.4 14.2287V7.92871H12.6V14.2287ZM12.6 6.52871H1.4V4.42871C1.4 4.24306 1.47375 4.06501 1.60503 3.93374C1.7363 3.80246 1.91435 3.72871 2.1 3.72871H2.8V4.42871C2.8 4.61436 2.87375 4.79241 3.00503 4.92369C3.1363 5.05496 3.31435 5.12871 3.5 5.12871C3.68565 5.12871 3.8637 5.05496 3.99497 4.92369C4.12625 4.79241 4.2 4.61436 4.2 4.42871V3.72871H9.8V4.42871C9.8 4.61436 9.87375 4.79241 10.005 4.92369C10.1363 5.05496 10.3143 5.12871 10.5 5.12871C10.6857 5.12871 10.8637 5.05496 10.995 4.92369C11.1263 4.79241 11.2 4.61436 11.2 4.42871V3.72871H11.9C12.0857 3.72871 12.2637 3.80246 12.395 3.93374C12.5263 4.06501 12.6 4.24306 12.6 4.42871V6.52871ZM3.5 10.7287C3.63845 10.7287 3.77378 10.6877 3.8889 10.6107C4.00401 10.5338 4.09373 10.4245 4.14672 10.2966C4.1997 10.1687 4.21356 10.0279 4.18655 9.89215C4.15954 9.75636 4.09287 9.63163 3.99497 9.53374C3.89708 9.43584 3.77235 9.36917 3.63656 9.34216C3.50078 9.31515 3.36003 9.32901 3.23212 9.382C3.10421 9.43498 2.99489 9.5247 2.91797 9.63981C2.84105 9.75493 2.8 9.89026 2.8 10.0287C2.8 10.2144 2.87375 10.3924 3.00503 10.5237C3.1363 10.655 3.31435 10.7287 3.5 10.7287ZM3.5 13.5287C3.63845 13.5287 3.77378 13.4877 3.8889 13.4107C4.00401 13.3338 4.09373 13.2245 4.14672 13.0966C4.1997 12.9687 4.21356 12.8279 4.18655 12.6921C4.15954 12.5564 4.09287 12.4316 3.99497 12.3337C3.89708 12.2358 3.77235 12.1692 3.63656 12.1422C3.50078 12.1152 3.36003 12.129 3.23212 12.182C3.10421 12.235 2.99489 12.3247 2.91797 12.4398C2.84105 12.5549 2.8 12.6903 2.8 12.8287C2.8 13.0144 2.87375 13.1924 3.00503 13.3237C3.1363 13.455 3.31435 13.5287 3.5 13.5287Z"
                fill="#004876"
            />
        </svg>
    </div>
</template>

<script>
import { DateTime } from 'luxon';
import { toDateString } from '@/../vue/online-booking/utils/dates';
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        Datepicker
    },

    props: {
        appointments: {
            type: Array,
            default: () => []
        },
        stringFormat: {
            type: String,
            default: 'd/M/yy'
        },
        value: {
            type: String,
            default: undefined
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data: function () {
        return {
            disabledDates: {
                customPredictor: (date) => {
                    const isSunday = DateTime.fromJSDate(date).toFormat('cccc') === 'Sunday';
                    if (!this.appointments.length) return isSunday; // No appointments passed, all dates except Sundays selectable
                    return isSunday || !this.availableDates.includes(toDateString(date));
                },
                to: DateTime.now().plus({ days: 1 }).toJSDate() // only future dates, next 48 hrs not included
            }
        };
    },

    computed: {
        availableDates() {
            return this.appointments.map((apt) => toDateString(apt.appointmentDate));
        },
        valueAsJsDate() {
            return this.value && DateTime.fromFormat(this.value, this.stringFormat).toJSDate();
        }
    },

    methods: {
        update(jsDateObj) {
            this.$emit('select', DateTime.fromJSDate(jsDateObj).toFormat(this.stringFormat));
        },
        formatter(jsDateObj) {
            return DateTime.fromJSDate(jsDateObj).toFormat('cccc d, MMMM yyyy');
        }
    }
};
</script>
<style>
.vdp-datepicker {
    @apply w-full bg-grey-100 py-4 px-6 text-blue-500 cursor-pointer;
}

.vdp-datepicker .vdp-datepicker__calendar {
    @apply border-none rounded overflow-hidden shadow-card w-full left-0 top-0;
    width: 318px;
}
@screen sm {
    .vdp-datepicker .vdp-datepicker__calendar {
        width: 352px;
    }
}

.vdp-datepicker input {
    @apply bg-transparent w-full;
}

.vdp-datepicker header span {
    @apply bg-yellow-500 text-blue-500 !important;
    padding: 5px 0;
}

.vdp-datepicker header span.prev:after {
    background-size: cover;
    height: 10px;
    width: 7px;
    border: none;
    background-image: url("data:image/svg+xml,%3Csvg width='7' height='11' viewBox='0 0 7 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.99156 5.29621L6.85963 1.20493L5.84256 0.189017L0.883789 5.27205L5.81725 10.4287L6.88379 9.36217L2.99156 5.29621Z' fill='%23004876'/%3E%3C/svg%3E%0A");
}

.vdp-datepicker header span.prev.disabled:after {
    @apply opacity-0;
}

.vdp-datepicker header span.next:after {
    background-size: cover;
    height: 10px;
    width: 7px;
    border: none;
    background-image: url("data:image/svg+xml,%3Csvg width='7' height='11' viewBox='0 0 7 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.77602 5.56121L0.90795 9.65249L1.92502 10.6684L6.88379 5.58537L1.95033 0.428711L0.883789 1.49525L4.77602 5.56121Z' fill='%23004876'/%3E%3C/svg%3E ");
}

.vdp-datepicker header + div {
    @apply px-2 pt-6 pb-4 flex items-center content-center flex-wrap;
}
@screen sm {
    .vdp-datepicker header + div {
        @apply px-6;
    }
}

.vdp-datepicker .vdp-datepicker__calendar .cell {
    @apply text-sm;
    width: 31px;
    height: 31px;
    margin: 6px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: none !important;
}

.cell.day:not(.disabled):not(.blank) {
    @apply bg-grey-100 rounded-full text-blue-500 border-none;
}

.vdp-datepicker .day-header {
    @apply text-blue-500;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled):not(.selected).day:hover {
    @apply text-white bg-blue-500 rounded-full;
}

.vdp-datepicker__calendar .cell.selected {
    @apply bg-yellow-500 rounded-full !important;
}
</style>
